(function () {
    "use strict";

    angular.module("app").component("habilCommentView", {
        restrict: "E",
        templateUrl: "@/comments/comment-view.template.html",
        bindings: { comment: "<", },
    });
})();
